import React, { useEffect, useState } from 'react'
import { Drawer, Button, Empty } from 'antd'
import './../../assets/scss/typography.scss'
import './index.scss'
import SearchList from 'components/shared/search/SearchList'
import useWindowDimensions from 'hooks/window-dimensions'

const ChooseCarDrawer = (props) => {
  const {
    isOpenPopupList,
    listData,
    onClose,
    buttonText = 'Quay lại',
    title = ' ',
    showSearch,
    onSearchCallback = () => {},
    onSelectedItemChanged
  } = props

  const { width } = useWindowDimensions()
  const [searchText, setSearchText] = useState(undefined)

  const handleChangeValue = async (item) => {
    onSelectedItemChanged(item)
    onClose()
  }

  const onSearch = (value) => {
    if (value?.length >= 2) {
      onSearchCallback(value.toLowerCase().trim())
    }
    if (!value || value?.length <= 0) {
      onSearchCallback('')
    }
  }

  useEffect(() => {
    onSearch()
  }, [searchText])

  return (
    <Drawer
      title={title}
      placement={'bottom'}
      width={width > 1280 ? '35%' : '100%'}
      onClose={onClose}
      open={isOpenPopupList}
      destroyOnClose
      className="popup-booking"
      bodyStyle={{ paddingBottom: 60 }} // để tránh footer che nội dung
    >
      {showSearch && (
        <SearchList
          placeholder="Tìm kiếm"
          value={searchText}
          onClick={() => {
            setSearchText(undefined)
          }}
          className="w-100"
          onSearch={onSearch}
          onInput={(e) => {
            if (e?.target?.value?.length === 0) {
              setSearchText(e.target.value)
            }
          }}
        />
      )}

      <div style={{ display: 'grid' }}>
        {listData.length > 0 ? (
          listData.map((item) => (
            <button
              key={item.value || item.status}
              className={`list-items ${item.disable ? 'disabled-item' : ''}`}
              style={{ border: 'none' }}
              disabled={item.disable}
              onClick={() => handleChangeValue(item)}>
              {item.status || item.value}
            </button>
          ))
        ) : (
          <div className="p-2">
            <Empty description="Không tìm thấy kết quả phù hợp" />
          </div>
        )}
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          padding: '12px 24px',
          borderTop: '1px solid #f0f0f0',
          background: '#fff',
          textAlign: 'center'
        }}>
        <Button className="btn-ok" onClick={onClose}>
          {buttonText}
        </Button>
      </div>
    </Drawer>
  )
}

export default ChooseCarDrawer
